module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2hxXw"))).then(() => parcelRequire('37nVf'));